import {sound as Sound} from '@pixi/sound';
import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {soundStore} from './SoundStore';
import {inject, CoreDI} from '@gongxigames/framework/core';
import {SlotSettings} from '@gongxigames/framework/slot';

export class SoundService extends UiServiceV2 {
    public static readonly NAME: symbol = Symbol('SoundService');

    @inject(CoreDI.Settings)
    private settings!: SlotSettings;

    onInit(): void {
        this.initStore();
        this.disableSoundsOnMobile();
    }

    onSetupEvents(): void {
        this.emitter.on('UI.sounds.enable', this.setSound.bind(this, true));
        this.emitter.on('UI.sounds.disable', this.setSound.bind(this, false));
        this.emitter.on('UI.sounds.toggle', this.onToggle.bind(this, false));
    }

    private disableSoundsOnMobile(): void {
        const soundEnabled = this.settings.get('soundEnabled');
        let soundsMuted = this.settings.get('soundsMuted') ?? false;

        if (!soundEnabled) {
            soundsMuted = true;
        }

        this.setSound(!soundsMuted);
    }

    private setSound(enabled: boolean) {
        enabled ?
            Sound.unmuteAll():
            Sound.muteAll();

        soundStore.slot_soundMuted.value = !enabled;
        this.settings.set('soundsMuted', !enabled);

        this.emitter.emit('UI.sounds.switchedTo', enabled);
    }

    private onToggle() {
        this.setSound(soundStore.slot_soundMuted.value);
    }

    private initStore() {
        soundStore.slot_soundMuted.value = this.settings.get('soundsMuted');
    }
}
